import * as HoverCard from "@radix-ui/react-hover-card";
import { useState } from "react";

import { CardContent } from "./CardContent";
import type { ProfileHoverCardProps } from "./HoverCard";

export const ProfileHoverCard = ({
  children,
  communityMemberId,
  publicUid,
  sqid,
  messagingEnabled,
  avatarURL,
  name = "",
  headline = "",
  disabled = false,
  side = "right",
  sideOffset = 5,
}: ProfileHoverCardProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <HoverCard.Root
      openDelay={300}
      closeDelay={100}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <HoverCard.Trigger asChild>
        <span>{children}</span>
      </HoverCard.Trigger>
      <HoverCard.Portal>
        {!disabled && (
          <CardContent
            communityMemberId={communityMemberId}
            publicUid={publicUid}
            sqid={sqid}
            avatarURL={avatarURL}
            name={name}
            headline={headline}
            messagingEnabled={messagingEnabled}
            closeCard={() => setIsOpen(false)}
            side={side}
            sideOffset={sideOffset}
          />
        )}
      </HoverCard.Portal>
    </HoverCard.Root>
  );
};
